module.exports = __webpack_public_path__ + "media/icons/twitter-25e10acf.png";